<template>
  <div class="jsyl-container" ref="container">
    <div class="jsyl-header">
      <span>
        <img :src="iconPaths.expand" alt="展开" @click="handleHistoryPopup" />
      </span>
      <span class="page-title">{{
        textTalkList[0] ? textTalkList[0].msgContent : pageTitle
      }}</span>
      <span class="right-icons">
        <img
          :src="iconPaths.chat"
          alt="新建文本对话"
          @click="addTextTalkItem"
        />
        <img
          class="icon-last"
          @click="goToVoiceTalk"
          :src="iconPaths.phone"
          alt="语音对话"
        />
      </span>
    </div>
    <div class="main-list-wrapper" v-if="textTalkList">
      <div class="jsyl-content-wrapper" v-if="!chatFlag">
        <div class="jsyl-content">
          <img :src="iconPaths.talkDefault" alt="默认" />
          <div class="default-title">您可以这样问</div>
          <div
            class="default-item"
            v-for="item in recommendList"
            :key="item"
            @click="inputAutoHandler(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div
        class="main-list"
        ref="miancroll"
        :style="getMainListHeight()"
        v-else
      >
        <div
          class="list-item"
          v-for="(item, index) in textTalkList"
          :key="index"
          v-show="!!item.msgContent"
        >
          <div class="now-time" v-if="item.type == 'question'">
            {{ item.time.slice(0, -3) || "" }}
          </div>
          <div class="item-lt" v-if="item.type == 'answer'">
            <div class="cont" :id="item.msgId">
              <div v-html="renderMd(item.msgContent)" />
              <!-- 添加操作图标 -->
              <div class="action-icons">
                <img
                  :src="iconPaths.copy"
                  alt="复制"
                  @click.stop="handleCopy(index)"
                  class="action-icon"
                />
                <img
                  :src="item.liked ? iconPaths.liked : iconPaths.noLike"
                  :alt="item.liked ? '已点赞' : '点赞'"
                  @click.stop="handleLike(index)"
                  class="action-icon"
                />
              </div>
            </div>
          </div>
          <div class="item-rt" v-else>
            <div class="cont">
              <div v-html="renderMd(item.msgContent)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jsyl-bottom">
      <van-field
        v-model="inputValue"
        center
        label=""
        placeholder="发消息，回复由AI生成"
      >
        <template #button>
          <van-button size="small" @click="send">发送</van-button>
        </template>
      </van-field>
    </div>
    <div id="associate-popup-container"></div>
    <history-popup
      :visible="historyPopupVisible"
      :closeOnClickOverlay="true"
      ref="historyPopup"
      :activeChat="activeChat"
      :historyList="historyList"
      :loading="historyPopuploading"
      :refreshing="historyPopupRefreshing"
      :finished="historyPopupFinished"
      @close="historyPopupVisible = false"
      @refresh="onHistoryRefresh"
      @load="onHistoryLoad"
      @item-click="handleHistoryItemClick"
    ></history-popup>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import { Field, Toast } from "vant";
import HistoryPopup from "@/components/HistoryPopup.vue";
import {
  getIndexData,
  questionsAndAnswers,
  getIndexDataDetail,
  islogin,
} from "@/api/theApi";
import * as sysTools from "../../utils/sysTools";

// 存储 event source
let stream;

export default {
  name: "JsylNew",
  components: {
    HistoryPopup,
    [Field.name]: Field,
  },
  data() {
    return {
      // 登陆状态
      islogin: false,
      // 当前正在进行的会话 ID
      conversationId: "",
      // 历史会话列表
      historyPopupVisible: false,
      historyList: [],
      historyPopuploading: false,
      historyPopupRefreshing: false,
      historyPopupFinished: false,
      historyPageIndex: 1,
      historyPageSize: 10,
      chatFlag: false, // 是否展示对话
      activeChat: {}, // 高亮的历史会话
      talkFlag: false, // 是否已经开始对话
      pageTitle: "文本对话",
      inputValue: "",
      textTalkList: [],
      iconPaths: {
        expand: require("@/assets/jsyl/jsyl-expand.png"),
        chat: require("@/assets/jsyl/jsyl-chat.png"),
        phone: require("@/assets/jsyl/jsyl-phone.png"),
        talkDefault: require("@/assets/jsyl/talk-default.png"),
        // 添加操作图标路径
        copy: require("@/assets/icon/copy.png"),
        noLike: require("@/assets/icon/no-like.png"),
        liked: require("@/assets/icon/liked.png"),
      },
      recommendList: [
        "帮我写一篇买入平安银行的分析报告",
        "分析首创环保的基本面",
      ],
      pressTimer: null,
      currentIndex: -1,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    };
  },
  async created() {
    this.init();
  },
  watch: {
    activeChat(newVal, oldVal) {
      // 切换对话后停止接收上一个对话（非新建对话）
      if (newVal.chatId !== oldVal.chatId && oldVal.chatId) {
        if (stream) {
          this.talkFlag = false;
          stream.close();
          stream = null;
        }
      }
    },
  },
  computed: {
    theUA() {
      return sysTools.getUA();
    },
    isWeiXin() {
      if (this.theUA.indexOf("micromessenger") !== -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    this.chatFlag = false;
    this.talkFlag = false;
    this.textTalkList = [];
    this.activeChat = {};
    this.conversationId = "";
    this.pageTitle = "文本对话";
    if (stream) {
      stream.close();
      stream = null;
    }
  },
  methods: {
    // 设置可滚动区域的高度
    getMainListHeight() {
      const layoutHeight = document.querySelector("#layout").clientHeight;
      const mainListHeight = this.isWeiXin
        ? layoutHeight - 12
        : layoutHeight - 62;
      return { height: mainListHeight + "px" };
    },
    //滚动条保持最底部方法
    scrollToBottom() {
      this.$nextTick(() => {
        var container = document.querySelector(".main-list");
        container.scrollTop = container.scrollHeight;
      });
    },
    // 获取消息纯文本内容（去除AI生成中的标记）
    getMessageText(index) {
      const item = this.textTalkList[index];
      let content = item.msgContent;

      // 如果是AI回复且包含"生成中"标记
      if (item.type === "answer" && content.includes("生成中")) {
        // 创建临时div解析HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;

        // 移除生成中标记
        const dots = tempDiv.querySelectorAll(".dot");
        dots.forEach((dot) => dot.remove());

        // 替换"生成中"文本
        return tempDiv.innerText.replace(/生成中/g, "").trim();
      }

      // 创建临时div获取纯文本
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = content;
      return tempDiv.innerText;
    },

    // 复制文本到剪贴板（兼容iOS）
    copyToClipboard(text) {
      // 使用现代Clipboard API（优先使用）
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            Toast({
              message: "已复制",
              icon: "passed",
            });
          })
          .catch((err) => {
            console.error("复制失败:", err);
            Toast.fail("复制失败");
          });
        return;
      }

      // iOS 设备使用 textarea 方法
      if (this.isIOS) {
        this.copyTextForIOS(text);
      }
      // 其他设备使用兼容方法
      else {
        this.copyByExecCommand(text);
      }
    },

    // iOS 专用复制方法
    copyTextForIOS(text) {
      try {
        // 创建可编辑的 textarea
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.contentEditable = "true";
        textArea.readOnly = false;

        // 设置样式（确保在可视区域外）
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        textArea.style.zIndex = "-1000";

        document.body.appendChild(textArea);

        // iOS 需要选中文本才能复制
        const range = document.createRange();
        range.selectNodeContents(textArea);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        textArea.setSelectionRange(0, 999999); // 选中所有文本

        // 执行复制命令
        const successful = document.execCommand("copy");

        // 清理
        document.body.removeChild(textArea);
        selection.removeAllRanges();

        if (successful) {
          Toast({
            message: "已复制",
            icon: "passed",
          });
        } else {
          throw new Error("execCommand failed");
        }
      } catch (error) {
        console.error("iOS复制失败:", error);
      }
    },

    // 兼容其他设备的复制方法
    copyByExecCommand(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          Toast({
            message: "已复制",
            icon: "passed",
          });
        } else {
          throw new Error("execCommand failed");
        }
      } catch (err) {
        console.error("复制失败:", err);
      } finally {
        document.body.removeChild(textArea);
      }
    },

    // 处理点赞
    handleLike(index) {
      if (index >= 0 && index < this.textTalkList.length) {
        const item = this.textTalkList[index];
        if (item.type === "answer") {
          // 切换点赞状态
          const newLiked = !item.liked;
          this.textTalkList.splice(index, 1, {
            ...item,
            liked: newLiked,
          });
          if (newLiked) {
            Toast.success("点赞成功");
          } else {
            Toast.success("取消点赞成功");
          }
        }
      }
    },

    // 执行复制操作
    handleCopy(index) {
      if (index >= 0 && index < this.textTalkList.length) {
        const text = this.getMessageText(index);
        this.copyToClipboard(text);
      }
    },
    // 获取历史会话列表
    async getHistoryList() {
      const res = await getIndexData();
      if (res.code === 20000) {
        this.historyList = res.data.records;
      }
    },
    async init() {
      // 登陆是否过期
      const theislogin = await islogin();
      this.islogin = theislogin.login_status;

      if (!theislogin.login_status) {
        Toast.fail("您已退出\n请重新登陆");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 2000);
      }
    },
    // 下拉刷新
    async onHistoryRefresh() {
      this.historyPopupRefreshing = true;
      this.historyPopupFinished = false;
      this.onHistoryLoad();
    },
    // 加载更多
    async onHistoryLoad() {
      // 如果是刷新操作，重置页码
      if (this.historyPopupRefreshing) {
        this.historyPageIndex = 1;
      }

      try {
        this.historyPopuploading = true;

        const res = await getIndexData({
          pageNum: this.historyPageIndex,
          pageSize: this.historyPageSize,
        });

        if (res.code === 20000) {
          // 合并新旧数据（分页追加）
          this.historyList = this.historyPopupRefreshing
            ? res.data.records
            : [...this.historyList, ...res.data.records];

          // 更新分页状态
          this.historyPopupFinished =
            res.data.records.length < this.historyPageSize;
          this.historyPageIndex++;
        }
      } catch (error) {
        console.error("加载历史记录失败", error);
      } finally {
        // 重置加载状态
        this.historyPopuploading = false;
        this.historyPopupRefreshing = false;
      }
    },
    // 处理列表项点击
    handleHistoryItemClick(item) {
      this.activeChat = item;
      this.chatFlag = true;
      this.getChatDetail();
    },
    async getChatDetail() {
      const res = await getIndexDataDetail(this.activeChat.chatId);
      if (res.code === 20000) {
        this.historyPopupVisible = false;
        // 构建 textTalkList
        this.textTalkList = res.data.map((msgItem) => ({
          ...msgItem,
          time: msgItem.msgTime,
          type: msgItem.msgType,
          liked: false, // 添加点赞状态
        }));
        this.conversationId = res.data[0].chatId || "";
      }
    },
    getCurrentTime() {
      // 获取当前时间的两种格式
      const now = new Date();
      const currentShortTime = `${String(now.getHours()).padStart(
        2,
        "0"
      )}:${String(now.getMinutes()).padStart(2, "0")}`;
      const currentFullTime = `${now.getFullYear()}-${
        now.getMonth() + 1
      }-${now.getDate()} ${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes()
      ).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
      console.log("当前时间:", currentShortTime);
      console.log("当前完整时间:", currentFullTime);
      return { currentShortTime, currentFullTime };
    },
    // 自动填充
    inputAutoHandler(fillContent) {
      this.inputValue = fillContent;
    },
    // 发送消息
    async send() {
      const content = this.inputValue;

      this.inputValue = "";
      if (!content) {
        Toast("请输入问题！");
        return;
      }
      if (this.talkFlag) {
        Toast("等待系统回复中...");
        return;
      }
      this.chatFlag = true;
      this.talkFlag = true;
      this.inputValue = "";

      this.$nextTick(() => {
        const scrollEl = this.$refs.miancroll;
        if (scrollEl) {
          scrollEl.scrollTo({
            top: scrollEl.scrollHeight,
          });
        }
      });

      // 添加用户发送的信息
      this.textTalkList.push({
        type: "question",
        msgContent: content,
        time: this.getCurrentTime().currentFullTime,
      });

      // 添加等待消息标识
      const WAITING_FLAG = "___waiting_message___";
      this.textTalkList.push({
        msgId: WAITING_FLAG,
        msgContent:
          '生成中<span class="dot"></span><span class="dot"></span><span class="dot"></span>',
        type: "answer",
        isWaiting: true,
        liked: false, // 添加点赞状态
      });

      // 创建 EventSource
      const baseUrl = "/v3/chat/submit";
      const queryParams = new URLSearchParams({
        content: content,
        chatId: this.conversationId,
      });
      stream = new EventSource(`${baseUrl}?${queryParams.toString()}`);

      stream.onopen = (event) => {};
      stream.onmessage = (event) => {
        // 收到第一条消息时，移除等待提示
        const waitingIndex = this.textTalkList.findIndex(
          (item) => item.msgId === WAITING_FLAG
        );
        if (waitingIndex !== -1) {
          this.textTalkList.splice(waitingIndex, 1);
        }

        const payload = JSON.parse(event.data);
        const { content: msgContent, status } = payload || {};
        this.$nextTick(() => {
          if (msgContent && status === 0 && msgContent.chatId) {
            this.conversationId = msgContent.chatId;
            this.activeChat = { chatId: msgContent.chatId };
            localStorage.conversationId = msgContent.chatId;

            const dotsHTML = `<span class="dot"></span><span class="dot"></span><span class="dot"></span>`;

            this.textTalkList.push({
              ...msgContent,
              msgContent: "" + `生成中${dotsHTML}`,
              status,
              type: "answer",
              time: msgContent.msgTime,
            });
          } else if (status === 1) {
            const index = this.textTalkList.findIndex(
              (f) => f.msgId === msgContent.msgId
            );
            const dotsHTML = `<span class="dot"></span><span class="dot"></span><span class="dot"></span>`;
            const newContent = msgContent.msgContent || "";

            if (index !== -1) {
              const currentItem = this.textTalkList[index];
              const baseContent = currentItem.msgContent
                .replace(/生成中<span.*<\/span>/, "")
                .replace(/<span.*<\/span>/, "");

              this.textTalkList.splice(index, 1, {
                ...currentItem,
                status,
                type: "answer",
                msgContent: `${baseContent}${newContent}${dotsHTML}`,
              });
            } else {
              this.textTalkList.push({
                ...msgContent,
                msgContent: `${msgContent.msgContent}${dotsHTML}`,
                status,
                type: "answer",
                time: msgContent.msgTime,
              });
            }

            this.$nextTick(() => {
              const scrollEl = this.$refs.miancroll;
              if (scrollEl) {
                scrollEl.scrollTo({
                  top: scrollEl.scrollHeight,
                });
              }
            });
          } else if (status === 2) {
            // 完成接收，移除最后的圆点动画
            const index = this.textTalkList.findIndex(
              (f) => f.msgId === msgContent.msgId
            );
            if (index !== -1) {
              const currentItem = this.textTalkList[index];
              const cleanContent = currentItem.msgContent.replace(
                /<span.*<\/span>/,
                ""
              );
              this.textTalkList.splice(index, 1, {
                ...currentItem,
                msgContent: cleanContent,
                liked: false, // 添加点赞状态
              });
            }

            this.talkFlag = false;
            stream.close();
          }
        });
      };

      stream.onerror = (error) => {
        // 出错时移除等待提示和圆点动画
        const waitingIndex = this.textTalkList.findIndex(
          (item) => item.msgId === WAITING_FLAG
        );
        if (waitingIndex !== -1) {
          this.textTalkList.splice(waitingIndex, 1);
        }
        const status1Index = this.textTalkList.findIndex(
          (item) => item.msgId && item.msgContent.includes("<span")
        );
        if (status1Index !== -1) {
          const currentItem = this.textTalkList[status1Index];
          const cleanContent = currentItem.msgContent.replace(
            /<span.*<\/span>/,
            ""
          );

          this.textTalkList.splice(status1Index, 1, {
            ...currentItem,
            msgContent: cleanContent,
          });
        }

        this.talkFlag = false;
        stream.close();
      };
    },
    renderMd(md) {
      const markdownIt = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      });
      return markdownIt.render(md || "");
    },
    addTextTalkItem() {
      this.chatFlag = false;
      this.conversationId = "";
      this.textTalkList = [];
      this.activeChat = {};
      this.talkFlag = false;
      this.pageTitle = "新对话";
      if (stream) {
        stream.close();
        stream = null;
      }
    },
    handleHistoryPopup() {
      this.historyPopupVisible = !this.historyPopupVisible;
      if (this.historyPopupVisible) {
        // 刷新历史会话列表
        this.onHistoryRefresh();
      }
    },
    goToVoiceTalk() {
      this.$router.push("/jsyl/voiceTalk");
    },
  },
};
</script>

<style lang="less" scoped>
.jsyl-container {
  width: 100%;
  height: calc(100vh - 100px);
  background-color: #fbfbfb;
  position: relative;
  overflow-y: hidden;
  .jsyl-header {
    padding: 16px 16px;
    display: flex;
    background-color: #fff;
    align-items: center;
    span {
      flex: 1;
    }
    img {
      width: 24px;
      display: inline-block;
    }
    img.icon-last {
      margin-left: 20px;
    }
    .page-title {
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .right-icons {
      text-align: right;
    }
  }
  .jsyl-content-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .jsyl-content {
      padding: 0 16px;
      display: flex;
      transform: translateY(-66px);
      align-items: center;
      flex-direction: column;
      > img {
        width: 88px;
      }
      .default-title {
        padding: 24px 0 12px;
        text-align: center;
        font-weight: 600;
        font-size: 20px;
      }
      .default-item {
        margin-top: 8px;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        color: #000000b2;
        border: 1px solid #00000033;
        border-radius: 20px;
        border-width: 1px;
        padding: 6px 12px;
        width: fit-content;
      }
    }
  }

  .main-list-wrapper {
    height: calc(100% - 143px);
  }
  .main-list {
    height: calc(100% + 166px);
    overflow-y: scroll;
    width: 354px;
    margin: 0 auto;
    box-sizing: border-box;
    border-radius: 10px;
    padding-bottom: 166px;
    display: flex;
    flex-direction: column;

    /* 隐藏滚动条样式 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Edge */
    }

    .list-item {
      width: 100%;
      margin-bottom: 20px;

      .now-time {
        // margin-bottom: 16px;
        padding: 8px 0;
        text-align: center;
        color: #00000080;
        font-weight: 400;
        font-size: 12px;
      }

      .item-lt {
        display: flex;
        width: 100%;

        .cont {
          padding: 16px;
          color: #000000;
          font-weight: 400;
          font-size: 14px;
          background: #eeeeee;
          line-height: 22px;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 8px;
          -webkit-user-select: none; /* 防止选中 */
          -webkit-touch-callout: none;
          user-select: none;
        }
        /* 添加操作图标样式 */
        .action-icons {
          display: flex;
          justify-content: flex-start;
          margin-top: 12px;
          .action-icon {
            width: 16px;
            margin-right: 16px;
            cursor: pointer;
          }
        }
      }

      .item-rt {
        display: flex;
        width: 100%;
        justify-content: flex-end;

        .cont {
          padding: 16px;
          color: #ffffff;
          font-weight: 400;
          font-size: 14px;
          background: linear-gradient(90deg, #ab7f36 0%, #7e5718 100%);
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 8px;
          border-bottom-left-radius: 20px;
          -webkit-user-select: none; /* 防止选中 */
          -webkit-touch-callout: none;
          user-select: none;
        }
      }
    }
  }
  .jsyl-bottom {
    padding: 16px 16px 16px;
    position: fixed;
    bottom: 50px;
    width: 100%;
    background: #fafafa;
    .van-field {
      border-radius: 20px;
      box-shadow: 0px 0px 6px -2px #00000040;
    }
    .van-button {
      border: none;
      color: #000;
      font-weight: 600;
      font-size: 18px;
    }
  }
}
</style>
<style>
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 2px;
  border-radius: 50%;
  background-color: #9b9b9b;
  /* 中间色 */
  animation: fade 1.5s infinite ease-in-out;
}

.dot:nth-child(1) {
  background-color: #cacaca;
  animation-delay: 0s;
}

.dot:nth-child(2) {
  background-color: #9b9b9b;
  animation-delay: 0.3s;
}

.dot:nth-child(3) {
  background-color: #595959;
  animation-delay: 0.6s;
}

.cont {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 16px 0 8px 0;
    font-weight: 600;
    line-height: 1.3;

    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 18px;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 15px;
  }
  h4,
  h5,
  h6 {
    font-size: 14px;
  }

  p {
    margin: 8px 0;
    line-height: 1.6;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 8px 0;
    padding-left: 20px;

    li {
      margin: 4px 0;
      line-height: 1.5;
    }
  }

  code {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 2px 4px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 13px;
  }

  pre {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 12px;
    margin: 8px 0;
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
      border-radius: 0;
    }
  }

  blockquote {
    border-left: 4px solid #e0e0e0;
    margin: 8px 0;
    padding: 8px 0 8px 12px;
    color: #666;
    font-style: italic;
  }

  a {
    color: #1976d2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  strong,
  b {
    font-weight: 600;
  }

  em,
  i {
    font-style: italic;
  }

  table {
    border-collapse: collapse;
    margin: 8px 0;
    width: 100%;
    font-size: 13px;

    th,
    td {
      border: 1px solid #e0e0e0;
      padding: 6px 8px;
      text-align: left;
    }

    th {
      background-color: rgba(0, 0, 0, 0.03);
      font-weight: 600;
    }
  }

  hr {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 16px 0;
  }
}

@keyframes fade {
  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}
</style>
